import { createSelector, createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory, DefaultFailureAction, DefaultSuccessAction } from "../common/reducers/utilities";
import { registerEntityBasedFetch } from "../common/hooks/initHook";

const compareLoginActivity = (a, b) => (a.eventtime === b.eventtime) && (a.username === b.username);

export const memberAuthActivitySlice = createSlice({
    name: 'memberAuthActivity',
    initialState: {
        data: {},
    },
    reducers: {
        set: (state, action) => {
            // NOTE: currently fetching only a single member at a time and memberid does not exist in data so adding all at once
            state.data[action.payload.memberid] = action.payload.data;
         },
        remove: (state, action) => {
            let idx = state.data[action.payload.memberid]?.findIndex(maa => compareLoginActivity(maa, action.payload));
            if (idx >= 0) {
                if (state.data[action.payload.memberid].length() === 1) {
                    delete state.data[action.payload.memberid]
                } else {
                    state.data[action.payload.memberid].splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => memberAuthActivitySlice.getInitialState());
    }
});

// #region network operations
const visualizeSuccess = (verb, action) => DefaultSuccessAction(verb, 'staffAuthActivity', action);
const visualizeFailure = verb => DefaultFailureAction(verb, 'staffAuthActivity');

const fetchMemberAuthActivity = memberid => network => network.get('/api/v1/memberAuthActivity/' + encodeURIComponent(memberid), data => memberAuthActivitySlice.actions.set({ data, memberid }) , visualizeFailure('get'))


// #endregion

// #region selectors
const selectMemberAuthActivityData = state => state.memberAuthActivity.data;
const selectMemberAuthActivity = memberid => createSelector([selectMemberAuthActivityData], maa => maa[memberid] ?? []);

// #endregion
const listen = {}
const memberAuthActivityByID = initMapFactory(fetchMemberAuthActivity, listen);
registerEntityBasedFetch('member', memberAuthActivityByID)

const cleanup = { root: memberAuthActivitySlice.name, all: state => Object.values(selectMemberAuthActivityData(state)).flat(), remove: maa => memberAuthActivitySlice.actions.remove(maa)};
export const [useMemberAuthActivity] = dataHookFactory(selectMemberAuthActivity, memberAuthActivityByID, {cleanup});

const reducer = { name: memberAuthActivitySlice.name, reducer: memberAuthActivitySlice.reducer }
export default reducer;